
import { computed, defineComponent, toRefs, watch } from "vue";
import ToolbarHeader from "./ToolbarHeader.vue";
import ToolbarFooter from "./ToolbarFooter.vue";
import ToolbarCalculator from "./ToolbarCalculator.vue";
import ToolbarFixes from "./ToolbarFixes.vue";
import useToolbar from "@/composables/useToolbar";

export default defineComponent({
  name: "Toolbar",
  components: {
    ToolbarHeader,
    ToolbarFooter,
    ToolbarCalculator,
    ToolbarFixes
  },
  setup() {
    const { current } = useToolbar();
    const { panel, closedPanels } = toRefs(current);

    const transition = computed(() =>
      panel.value === "ToolbarCalculator" ? `slide-left` : `slide-right`
    );

    watch(panel, (panel, prevPanel) =>
      prevPanel !== "ToolbarCalculator"
        ? closedPanels.value.push("Page Size")
        : closedPanels.value.splice(closedPanels.value.indexOf("Page Size"))
    );

    const afterEnter = (el: {
      classList: DOMTokenList;
      offsetParent: HTMLElement;
    }) => {
      if (!el.classList.contains("fixes-wrap")) return;
      el.offsetParent.scrollTo({ top: 0, behavior: "smooth" });
    };

    return { panel, transition, afterEnter };
  }
});
